import script from "./Root.vue?vue&type=script&setup=true&lang=ts"
export * from "./Root.vue?vue&type=script&setup=true&lang=ts"

import "./Root.vue?vue&type=style&index=0&id=44f744a1&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44f744a1"]])

export default __exports__